<div class="dashBookingOverlay">
    <div class="bg"></div>

    <div class="content">
        <div class="header">
            <div class="title">BOOKING REQUEST</div>

            <div class="close" (click)="close()">
                <mat-icon>close</mat-icon>
            </div>
        </div>

        <div class="content">
            <div class="bookingNo">
                <div class="bookingLabel">BOOKING #</div>

                <div class="right">

                    <!-- <div class="bookingID">33267-ID</div> -->
                    <div class="bookingID">{{bookingService.dashBooking?.id}}</div>

                    <div class="buttons">
                        <a [href]="'mailto:' + bookingService.dashBooking?.profile?.email" target="_blank">
                            <div class="button">
                                <div class="label">
                                    Email Client
                                </div>
                            </div>
                        </a>
                        <!-- <a [href]="'mailto:' + bookingService.dashBooking?.profile?.email" target="_blank"> -->
                        <div class="button">
                            <div class="label">
                                Email Sales Rep
                            </div>
                        </div>
                        <!-- </a> -->
                    </div>
                </div>
            </div>

            <div class="movieInfoHolder">
                <div class="posterWrapper">

                    <div class="poster">
                        <img [src]="bookingService.dashBooking?.movie?.Poster" alt="">
                    </div>
                </div>
                <div class="infoHolder">
                    <div class="title">{{bookingService.dashBooking?.movie?.Title}}</div>

                    <div class="split1 space2">
                        <div class="date">
                            <div class="label">
                                START DATE
                            </div>
                            <div class="cont">
                                {{bookingService.dashBooking?.startDate?.toDate() | momentFormat: "MM/DD/YY"}}
                            </div>
                        </div>
                        <div class="date">
                            <div class="label">
                                END DATE
                            </div>
                            <div class="cont">
                                {{bookingService.dashBooking?.endDate?.toDate() | momentFormat: "MM/DD/YY"}}
                            </div>
                        </div>
                    </div>

                    <div class="split2">
                        <div class="left">
                            <div class="date">
                                <div class="label">
                                    NAME:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.userName}}
                                </div>
                            </div>

                            <div class="date">
                                <div class="label">
                                    EMAIL:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.profile?.email}}
                                </div>
                            </div>

                            <div class="date">
                                <div class="label">
                                    PHONE:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.profile?.phone}}
                                </div>
                            </div>

                            <br><br>
                            <div class="date spaceTop">
                                <div class="label">
                                    FORMAT:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.format}}
                                </div>
                            </div>

                            <div class="date sp3">
                                <div class="label">
                                    ADMISSION CHARGED:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.admission | yesNo }}
                                </div>
                            </div>

                            <div class="date sp3">
                                <div class="label">
                                    TERMS:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.terms }}
                                </div>
                            </div>

                        </div>





                        <div class="right">
                            <div class="date" *ngIf="!bookingService.dashBooking?.enableMultipleTheaters">
                                <div class="label">
                                    THEATER NAME:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.theater}}
                                </div>
                            </div>

                            <div class="date" *ngIf="!bookingService.dashBooking?.enableMultipleTheaters">
                                <div class="label">
                                    CITY:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.city}}
                                </div>
                            </div>

                            <div class="date" *ngIf="!bookingService.dashBooking?.enableMultipleTheaters">
                                <div class="label">
                                    STATE:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.state}}
                                </div>
                            </div>

                            <div class="date" *ngIf="bookingService.dashBooking?.enableMultipleTheaters">
                                <div class="label">
                                    THEATAERS:
                                </div>
                                <div class="cont" *ngFor="let theater of bookingService.dashBooking?.theaterListObj">
                                    {{theater.name}} <br> {{theater.city}}, {{theater.state}}
                                    <br><br>
                                </div>
                            </div>
                            

                        </div>


                    </div>

        






                    <div class="date space sp3">
                        <div class="label">
                            NOTES:
                        </div>
                        <div class="cont">
                            {{bookingService.dashBooking?.notes }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="movieInfoHolder">
                <div class="posterWrapper">

                    <div class="poster">
                        <!-- <img [src]="bookingService.dashBooking?.movie?.Poster" alt=""> -->
                    </div>
                </div>
                <div class="infoHolder">
                    <div class="split2">
                        <div class="left">

                            <div class="date">
                                <div class="label">
                                    STATUS:
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.status}}
                                </div>
                            </div>
                            <div class="date sp3">
                                <div class="label">
                                    DATE OF REQUEST
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.created?.toDate() | momentFormat: "MM/DD/YY"}}
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="date">
                                <div class="label">
                                    SALES REP
                                </div>
                                <div class="cont">
                                    {{bookingService.dashBooking?.salesRep}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <div class="buttons">
                <div class="button" (click)="onApproveBooking()">
                    <div class="label">
                        Approve
                    </div>
                </div>
                <div class="button" (click)="onDeniedBooking()">
                    <div class="label">
                        Deny
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>